<!-- <ng-container *ngIf="desktop | async"> -->
  <!-- <app-header *ngIf="showHeader | async"></app-header> -->
  <!-- <app-header></app-header> -->
<!-- </ng-container> -->
 <!-- <app-page>

 </app-page> -->

 <!-- todo move this to page component, add padding top to page component on mobile to offset -->
<div class="logo-container" *ngIf="showMobileHeader | async">
  <a [routerLink]="['/']" class="logo">
    <app-logo></app-logo>
  </a>
</div>

<div class="main-content" role="main">
  <router-outlet></router-outlet>
</div>
<div #footer></div>
<ng-container *ngIf="showFooter | async">
  <!-- @defer { -->
    <app-directory></app-directory>
    <app-footer></app-footer>
  <!-- } @placeholder {
    <div></div>
  } -->
</ng-container>

<ng-container *ngIf="isBrowser">
  <ng-container *ngIf="login | async" i18n>
    <div class="login-backdrop">
      <div class="login-modal" @fadeIn (outsideClick)="close()">
        <div class="close-button-wrapper" (click)="close()">
          <svg-icon [svgStyle]="{'width.px': 18, 'height.px': 18}" src="assets/icons/x.svg"></svg-icon>
        </div>
        <div class="logo">
          <app-logo></app-logo>
        </div>
        <div class="message">
          <div class="title">Web app coming soon!</div>
          <div class="content">
            <div class="text">
              Come back to access our full catalogue of hostels. We will be launching to travelers in spring 2024. Sign up to our newsletter to find out more about our release date and how you can save on bookings with Hostel Hop.
            </div>
            <div class="form">
              <input placeholder="Email" class="input-inline" [(ngModel)]="email" />
            </div>
          </div>
        </div>
        <div class="button-wrapper">
          <button class="btn btn-theme btn-large" (click)="inviteBackpacker()">
            <span>Stay updated</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showLocaleModal$ | async">
    <div class="login-backdrop">
      <app-locale-modal @fadeIn (outsideClick)="closeLocaleModal()"></app-locale-modal>
    </div>
  </ng-container>
</ng-container>

<app-seo></app-seo>
